// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2qOwL","checkboxCol":"Table_checkboxCol__1s5cs","emailCol":"Table_emailCol__3vK5D","actionCol":"Table_actionCol__1kfBB"};